import { getDeviceType } from '@pba/static-data';
import type { InternalAxiosRequestConfig } from 'axios';
import { appVersion } from '../api-keys';

export const defaultHeadersInterceptor = (config: InternalAxiosRequestConfig) => {
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
  if (config.headers) {
    config.headers['x-app-name'] = String(import.meta.env.VITE_APP_CONFIG);
    config.headers['x-app-platform'] = 'fe';
    config.headers['x-app-version'] = appVersion;
    config.headers['x-device-type'] = getDeviceType();
  }

  return config;
};
